<template>
  <div class="vx-col md:w-full">
    <v-select v-model="baud_rate" :options="OSDP_List" class="select_padding update_time mt-5" name="OSDP"
      placeholder="OSDP" :reduce="(item) => item.id" @input="changeBaud_rate" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
  </div>
</template>


<script>
import vSelect from "vue-select";
export default {
  props: {},
  watch: {
    baud_rate: {
      handler: function (data) {
        this.$store.commit("accessPoint/UPDATE_OSDP", data);
      },
      deep: true,
    },
  },
  methods: {
    changeBaud_rate(data) {
      this.baud_rate = data;
    },
  },
  data() {
    return {
      baud_rate: 38400,
      OSDP_List: [
          {
            id: 2400,
            label: "2400",
          },
          {
            id: 9600,
            label: `9600`,
          },
          {
            id: 19200,
            label: `19200`,
          },
          {
            id: 28800,
            label: `28800`,
          },
          {
            id: 38400,
            label: `38400`,
          },
          {
            id: 57600,
            label: `57600`,
          },
        ],
    };
  },
  created() {
    this.baud_rate = this.$store.state.accessPoint.edit_acu_data.baud_rate;
  },
  components: { vSelect },
};
</script>
